export const SIGNATURE_DASH_IMG: string =
  'data:image/png;base64,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';

export class TabletSignEditor {
  public historyCommands: any[][] = [[]];
  public buffer: any[] = [];
  private canvasWidth: number;
  private canvasHeight: number;
  private ctx: CanvasRenderingContext2D;
  public clearImage: string =
    'data:image/png;base64,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';
  private editorState: TabletEditorState = TabletEditorState.Usual;

  public get getLastOperatingStack(): any[] {
    return this.historyCommands[this.historyCommands.length - 1];
  }

  public get getNextCommand(): string {
    return this.getLastOperatingStack[this.getLastOperatingStack.length - 1].command;
  }

  public get getUsualState(): boolean {
    return this.editorState === TabletEditorState.Usual;
  }

  public get getDashState(): boolean {
    return this.editorState === TabletEditorState.Dash;
  }

  public get getEraseState(): boolean {
    return this.editorState === TabletEditorState.Erase;
  }

  private get getLastBufferRecord(): any {
    return this.buffer[this.buffer.length - 1];
  }

  public runEditor(image: string, ctx: CanvasRenderingContext2D, width: number, height: number) {
    this.getLastOperatingStack.push({ command: 'start', value: image });
    this.canvasWidth = width;
    this.canvasHeight = height;
    this.ctx = ctx;
    this.renderCanvas(() => {});
  }

  public updateCtx(ctx: CanvasRenderingContext2D) {
    this.ctx = ctx;
  }

  public rotateImage(deg: number) {
    this.getLastOperatingStack.push({ command: 'rotate', value: deg });
    this.buffer = [];
    this.renderCanvas(() => {});
  }

  public zoomImage(ratio: number) {
    this.getLastOperatingStack.push({ command: 'zoom', value: ratio });
    this.buffer = [];
    this.renderCanvas(() => {});
  }

  public translateImage(stepX: number, stepY: number) {
    this.getLastOperatingStack.push({ command: 'translate', value: [stepX, stepY] });
    this.buffer = [];
    this.renderCanvas(() => {});
  }

  public line(x1: number, y1: number, x2: number, y2: number, mode: string) {
    this.getLastOperatingStack.push({ command: 'line', value: [x1, y1, x2, y2], mode: mode });
    this.buffer = [];
    this.editorState = TabletEditorState.Usual;
  }

  public undoImage() {
    this.buffer[this.buffer.length] = this.getLastOperatingStack.pop();
    if (
      this.getLastBufferRecord.command == 'new_photo' ||
      this.getLastBufferRecord.command == 'erase' ||
      this.getLastBufferRecord.command == 'dash'
    ) {
      this.return2PreviousPhoto();
    }
    this.checkState(this.getLastBufferRecord.command);
    this.renderCanvas(() => {});
  }

  private return2PreviousPhoto() {
    this.historyCommands.pop();
  }

  public redoImage() {
    const lastBufferRecord = this.getLastBufferRecord;
    this.buffer.pop();
    switch (lastBufferRecord.command) {
      case 'new_photo':
        this.receivedNewPhoto(lastBufferRecord.value, () => {}, true);
        break;
      case 'erase':
        this.eraseCanvas(() => {}, true);
        break;
      case 'dash':
        this.dashCanvas(() => {}, true);
        break;
      default:
        this.getLastOperatingStack.push(lastBufferRecord);
        this.renderCanvas(() => {});
        break;
    }
  }

  public eraseCanvas(onRendered: () => void, afterRedo?: boolean) {
    this.historyCommands[this.historyCommands.length] = [];
    this.getLastOperatingStack.push({ command: 'erase', value: this.clearImage });
    if (!afterRedo) {
      this.buffer = [];
    }
    this.renderCanvas(onRendered);
  }

  public dashCanvas(onRendered: () => void, afterRedo?: boolean) {
    this.historyCommands[this.historyCommands.length] = [];
    this.getLastOperatingStack.push({ command: 'dash', value: SIGNATURE_DASH_IMG });
    if (!afterRedo) {
      this.buffer = [];
    }
    this.renderCanvas(onRendered);
  }

  public receivedNewPhoto(img: string | null, onRendered: () => void, afterRedo?: boolean) {
    if (img) {
      this.historyCommands[this.historyCommands.length] = [];
      this.getLastOperatingStack.push({ command: 'new_photo', value: img });
      if (!afterRedo) {
        this.buffer = [];
      }
    }
    this.renderCanvas(onRendered);
  }

  private renderCanvas(onRendered: () => void) {
    this.checkState(this.getLastOperatingStack[this.getLastOperatingStack.length - 1].command);
    const img = new Image();
    img.src = this.getLastOperatingStack[0].value;
    img.onload = () => {
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      for (let i = this.getLastOperatingStack.length - 1; i >= 0; i--) {
        switch (this.getLastOperatingStack[i].command) {
          case 'rotate':
            this.performRotate(i);
            break;
          case 'zoom':
            this.performZoom(i);
            break;
          case 'translate':
            this.performTranslate(i);
            break;
          case 'line':
            this.getLastOperatingStack[i].transform = this.ctx.getTransform();
            break;
        }
      }
      this.ctx.drawImage(img, (this.canvasWidth - img.width) / 2, (this.canvasHeight - img.height) / 2);
      for (let i = 0; i < this.getLastOperatingStack.length; i++) {
        switch (this.getLastOperatingStack[i].command) {
          case 'line':
            this.performLine(i, this.getLastOperatingStack[i].mode);
            break;
        }
      }
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
      onRendered();
    };
  }

  private checkState(command: string) {
    switch (command) {
      case 'erase':
        this.editorState = TabletEditorState.Erase;
        break;
      case 'dash':
        this.editorState = TabletEditorState.Dash;
        break;
      default:
        this.editorState = TabletEditorState.Usual;
        break;
    }
  }

  private performRotate(i: number) {
    this.ctx.translate(this.canvasWidth / 2, this.canvasHeight / 2);
    this.ctx.rotate((this.getLastOperatingStack[i].value * Math.PI) / 180);
    this.ctx.translate(-this.canvasWidth / 2, -this.canvasHeight / 2);
  }

  private performZoom(i: number) {
    this.ctx.translate(this.canvasWidth / 2, this.canvasHeight / 2);
    this.ctx.scale(this.getLastOperatingStack[i].value, this.getLastOperatingStack[i].value);
    this.ctx.translate(-this.canvasWidth / 2, -this.canvasHeight / 2);
  }

  private performTranslate(i: number) {
    this.ctx.translate(this.getLastOperatingStack[i].value[0], this.getLastOperatingStack[i].value[1]);
  }

  private performLine(i: number, mode: string) {
    const x1 = this.getLastOperatingStack[i].value[0];
    const y1 = this.getLastOperatingStack[i].value[1];
    const x2 = this.getLastOperatingStack[i].value[2];
    const y2 = this.getLastOperatingStack[i].value[3];
    this.ctx.strokeStyle = mode == 'drawing' ? 'black' : 'white';
    this.ctx.lineWidth = mode == 'drawing' ? 2 : 16;
    this.ctx.setTransform(this.getLastOperatingStack[i].transform);
    this.ctx.beginPath();
    this.ctx.moveTo(x1, y1);
    this.ctx.lineTo(x2, y2);
    this.ctx.stroke();
  }
}

export enum TabletEditorState {
  Usual,
  Dash,
  Erase,
}
